module.exports = __webpack_public_path__ + "media/bootstrap-icons/sd-card-fill-a26c03c6.svg";